module.exports = __webpack_public_path__ + "static/media/gamex_sat_en.508fd313.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/gamex_sat_en.ogv
// module id = 84
// module chunks = 0